// Hide Redo checkbox and update data attributes when variant is sold out - updates dynamically when variants change
(function () {
  var NO_BIS_STATUS = { eol: 1, eod: 1, closeout: 1, 'current no reorder': 1 };

  function normStatus(raw) {
    if (raw == null || raw === '') return '';
    return String(raw)
      .trim()
      .toLowerCase()
      .replace(/-/g, ' ')
      .replace(/\s+/g, ' ');
  }

  function statusSuppressesBis(raw) {
    return NO_BIS_STATUS.hasOwnProperty(normStatus(raw));
  }

  function statusMapFrom(container) {
    var el = container && container.querySelector('script[data-variant-item-status-map]');
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function variantPickerData(variantRadios) {
    if (!variantRadios) return null;
    var s =
      variantRadios.querySelector('script[type="application/json"][data-allow-placeholder]') ||
      variantRadios.querySelector('script[type="application/json"]');
    if (!s || !s.textContent) return null;
    try {
      return JSON.parse(s.textContent);
    } catch (e) {
      return null;
    }
  }

  function findVariant(data, id) {
    if (!data || id == null || id === '') return null;
    id = String(id);
    for (var i = 0; i < data.length; i++) {
      if (String(data[i].id) === id) return data[i];
    }
    return null;
  }

  function variantIdFromUrl() {
    try {
      var v = new URLSearchParams(window.location.search).get('variant');
      if (v && /^\d+$/.test(String(v).trim())) return String(v.trim());
    } catch (e) {}
    return '';
  }

  function currentVariantId(elements, map, data) {
    var inp =
      (elements.buyButtonsContainer && elements.buyButtonsContainer.querySelector('input.product-variant-id')) ||
      elements.variantInput;
    if (inp && inp.value) return String(inp.value);
    var cv = elements.variantRadios && elements.variantRadios.currentVariant;
    if (cv && cv.id != null) return String(cv.id);
    var urlId = variantIdFromUrl();
    if (urlId && map && Object.prototype.hasOwnProperty.call(map, urlId)) return urlId;
    if (urlId && data && findVariant(data, urlId)) return urlId;
    return urlId || '';
  }

  function variantIsAvailable(vid, elements, data) {
    var row = data && findVariant(data, vid);
    if (row) return !!row.available;
    var cv = elements.variantRadios && elements.variantRadios.currentVariant;
    if (cv && String(cv.id) === String(vid)) return !!cv.available;
    if (elements.submitButton && elements.submitButton.hasAttribute('disabled')) return false;
    return true;
  }

  function syncKlaviyoTriggers(container, oos, klOn, suppressed) {
    if (!container || !klOn) return;
    container.querySelectorAll('.product-form .klaviyo-bis-trigger').forEach(function (el) {
      if (!oos || suppressed) el.style.setProperty('display', 'none', 'important');
      else el.style.removeProperty('display');
    });
  }

  let cachedElements = null;
  let debounceTimer = null;

  function getCachedElements() {
    if (!cachedElements) {
      cachedElements = {
        variantRadios: document.querySelector('variant-radios') || document.querySelector('variant-selects'),
        buyButtonsContainer: document.querySelector('.product--buy-buttons'),
        productInfoContainer: document.querySelector('.product__info-container'),
        productInfoWrapper: document.querySelector('.product__info-wrapper'),
        variantInput: document.querySelector('input[name="id"]'),
        section: document.querySelector('[data-section]'),
        redoElements: null
      };
      const sectionId = cachedElements.section?.dataset?.section || '';
      cachedElements.submitButton = document.querySelector('#ProductSubmitButton-' + sectionId);
      if (cachedElements.productInfoContainer) {
        cachedElements.redoElements = cachedElements.productInfoContainer.querySelectorAll(
          '[class*="redo"], [id*="redo"], [class*="Redo"], [id*="Redo"]'
        );
      }
    }
    return cachedElements;
  }

  function updateVariantAttributes() {
    const elements = getCachedElements();
    const { variantRadios, buyButtonsContainer, productInfoContainer, submitButton } = elements;
    if (!buyButtonsContainer || !productInfoContainer) return;

    const map = statusMapFrom(buyButtonsContainer);
    const data = variantPickerData(variantRadios);
    const vid = currentVariantId(elements, map, data);

    let oos = false;
    if (vid) oos = !variantIsAvailable(vid, elements, data);
    else if (variantRadios && variantRadios.currentVariant) oos = !variantRadios.currentVariant.available;
    else if (submitButton && submitButton.hasAttribute('disabled')) oos = true;

    const hasOosMetafield = buyButtonsContainer.getAttribute('data-oos-override') !== null;
    const shouldShowOosOverride = hasOosMetafield && oos;

    const klOn = buyButtonsContainer.getAttribute('data-klaviyo-bis-enabled') === 'true';
    const suppressed = statusSuppressesBis(vid ? map[vid] : '');
    buyButtonsContainer.dataset.bisItemStatusSuppressed = suppressed ? 'true' : 'false';

    const showKlaviyoBis = klOn && !suppressed;
    if (submitButton) {
      submitButton.classList.toggle('hide', oos && showKlaviyoBis && !shouldShowOosOverride);
    }
    syncKlaviyoTriggers(buyButtonsContainer, oos, klOn, suppressed);

    buyButtonsContainer.dataset.variantUnavailable = oos;
    buyButtonsContainer.dataset.oosOverride = shouldShowOosOverride;
    buyButtonsContainer.classList.toggle('variant-sold-out', oos);
    buyButtonsContainer.classList.toggle('oos-override-active', shouldShowOosOverride);

    productInfoContainer.dataset.variantUnavailable = oos;
    productInfoContainer.classList.toggle('variant-sold-out', oos);

    updateButtonState(submitButton, oos, shouldShowOosOverride);
    hideRedoCheckbox();
  }

  function updateButtonState(button, isUnavailable, showCustomText) {
    if (!button) return;
    const buttonSpan = button.querySelector('span');
    if (!buttonSpan) return;
    const customOosText = button.closest('.product--buy-buttons')?.getAttribute('data-oos-text');
    if (isUnavailable) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      if (showCustomText && customOosText) {
        buttonSpan.textContent = customOosText;
        button.classList.add('button--out-of-stock');
      } else {
        buttonSpan.textContent = button.getAttribute('data-sold-out-text') || 'Sold Out';
        button.classList.remove('button--out-of-stock');
      }
    } else {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
      buttonSpan.textContent = button.getAttribute('data-add-to-cart-text') || 'Add to Cart';
      button.classList.remove('button--out-of-stock');
    }
  }

  function hideRedoCheckbox() {
    const elements = getCachedElements();
    const { buyButtonsContainer, productInfoContainer, productInfoWrapper, redoElements } = elements;
    const isVariantUnavailable = buyButtonsContainer?.dataset.variantUnavailable === 'true';
    const hasMetafieldOverride = buyButtonsContainer?.dataset.oosOverride === 'true';
    if (!productInfoContainer || !redoElements) return;
    const shouldHide = isVariantUnavailable || hasMetafieldOverride;
    redoElements.forEach(function (el) {
      if (productInfoContainer.contains(el) || productInfoWrapper?.contains(el)) {
        el.style.display = shouldHide ? 'none' : '';
        el.style.visibility = shouldHide ? 'hidden' : '';
        el.style.opacity = shouldHide ? '0' : '';
        el.style.height = shouldHide ? '0' : '';
        el.style.overflow = shouldHide ? 'hidden' : '';
      }
    });
  }

  function debouncedUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateVariantAttributes, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVariantAttributes);
  } else {
    updateVariantAttributes();
  }

  document.addEventListener('variantChanged', updateVariantAttributes);

  function setupListeners() {
    const elements = getCachedElements();
    if (elements.variantRadios) {
      elements.variantRadios.addEventListener('change', updateVariantAttributes);
    }
    if (elements.variantInput) {
      elements.variantInput.addEventListener('change', updateVariantAttributes);
    }
    if (window.MutationObserver && elements.submitButton) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type === 'attributes' && m.attributeName === 'disabled') debouncedUpdate();
        });
      }).observe(elements.submitButton, { attributes: true, attributeFilter: ['disabled'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupListeners);
  } else {
    setupListeners();
  }
})();
